import React from 'react';
import RenderRevisionNodes from '../../../Documents/components/RenderRevisionNodes';

/**
 * DeleteOriginalPreview Component
 * Shows the current state of the document before delete
 */
const DeleteOriginalPreview = ({ data, deleteDocument }) => {
  if (!data || !deleteDocument) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '40px',
        color: '#666'
      }}>
        <p>Loading original document...</p>
      </div>
    );
  }

  return (
    <div>
      <RenderRevisionNodes
        partRef={deleteDocument.partId}
        procedureRevRef={deleteDocument.revisionId}
        partNumber={deleteDocument.partNumber}
        revision={deleteDocument.revision}
        disabled={true}
        showCheckbox={false}
        preloadedData={data}
        forceShowChildHeadings={true}
      />
    </div>
  );
};

export default DeleteOriginalPreview;

